var _symbol, _use, _view;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "oil-icon",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.835 12.676a.568.568 0 01-.329.598l-8.445 3.808c-.5.227-1.083.197-1.557-.076l-6.385-3.687a1.707 1.707 0 01-.625-2.33l1.5-2.598-1.569-1.77a1.703 1.703 0 01-.2-1.985l.506-.878a1.704 1.704 0 012.753-.279L6.76 4.92l2.382 1.375.568-.984-1.476-.853a.568.568 0 01.568-.985l3.938 2.274a.569.569 0 01-.568.985l-1.477-.853-.568.985 2.053 1.185c.395.228.677.596.795 1.036l.613 2.288 5.764.82c.25.036.447.233.482.483zm-16.56-6.81l1.319 1.487L5.7 5.437 4.633 4.234a.568.568 0 00-.917.093l-.507.878a.568.568 0 00.067.66zm7.317 10.18l1.01-.455-7.839-4.525-.284.492a.57.57 0 00.208.776l6.385 3.687a.57.57 0 00.52.025zm2.286-1.03l4.375-1.973-4.196-.597a.568.568 0 01-.47-.416l-.71-2.651a.564.564 0 00-.264-.345L6.605 6.143c-.048.084-2 3.463-2.273 3.938l8.546 4.934zm8.251 2.731a2.276 2.276 0 01-2.004 3.349 2.276 2.276 0 01-2.004-3.349l1.49-3.147a.569.569 0 011.028 0l1.49 3.147zm-2.004 2.212a1.138 1.138 0 00.983-1.711l-.983-2.077-.983 2.077a1.121 1.121 0 00-.154.574c0 .627.51 1.137 1.137 1.137z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oil-icon"
  })), _view || (_view = /*#__PURE__*/React.createElement("view", {
    id: "oil-icon"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilIcon);
export default __webpack_public_path__ + "static/media/oilIcon.540d59b454e6f2029a1223a7cec1601e.svg";
export { ForwardRef as ReactComponent };